import { useEffect } from 'react';
import { Box, Grid, Typography, styled } from '@mui/material';
import { useLocation } from 'react-router-dom';

// component
import Iconify from '../../../components/Iconify';
import { NAVBAR } from '../../../config';
import Image from '../../../components/Image';
import Home from '../../../assets/bottom-nav/Home.png';
import History from '../../../assets/bottom-nav/History.png';
import Promo from '../../../assets/bottom-nav/Promo.png';
import LiveChat from '../../../assets/bottom-nav/LiveChat.png';
import Settings from '../../../assets/bottom-nav/Settings.png';

const BottomMenuBox = styled(Box)(({ theme }) => ({
  background: '#E2AC0D',
  width: '100%',
  height: NAVBAR.MOBILE_MENU,
  position: 'fixed',
  bottom: 0,
  left: 0,
  zIndex: 100,
  display: 'block',
  right: 0,
  boxShadow: '0px 0px 15px 6px rgba(255, 255, 255, 0.2)',
  borderTopLeftRadius: '30px',
  borderTopRightRadius: '30px',
}));

const BottomMenuLabel = styled(Typography)(({ theme }) => ({
  fontWeight: ICON_SIZE,
  textTransform: 'uppercase',
  [theme.breakpoints.only('xs')]: {
    fontSize: '2.4vw',
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '1.5vw',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1vw',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '0.7rem',
  },
}));

const MenuGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  flexDirection: 'column',
  // backgroundColor: '#1F1F1F',
}));

const MenuBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'red',
  alignItems: 'center',
  justifyContent: 'end',
  flexFlow: 'column',
  padding: '5px 15px',
  borderTopLeftRadius: 8,
  borderTopRightRadius: 8,
  [theme.breakpoints.up('sm')]: {
    maxWidth: 'unset',
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: '20vw',
  },
}));

const CurvedText = styled('text')(({ theme }) => ({
  fontWeight: 600,
  textTransform: 'uppercase',
  fill: '#fff',
  letterSpacing: '3px',
  fontSize: '6px',
}));

const CurvedLabel = ({ children }) => {
  return (
    <svg width="120" height="30">
      <defs>
        <path id="curveText" d="M 10,46 A 50,50 0 0 1 108,50" />
      </defs>

      <CurvedText
        sx={{
          zIndex: 1,
        }}
      >
        <textPath href="#curveText" startOffset="50%" textAnchor="middle">
          {children}
        </textPath>
      </CurvedText>
    </svg>
  );
};

const ICON_SIZE = 55;
const TEXT_SIZE = 60;

const BottomMenu = ({
  isAuthenticated,
  dispatch,
  setMenuIndex,
  setActiveTab,
  navigate,
  menuIndex,
  handleOpen,
  translate,
}) => {
  const location = useLocation();

  return (
    <BottomMenuBox>
      <Grid container sx={{ height: '100%' }}>
        <MenuGrid
          onClick={() => {
            setMenuIndex(1);
            dispatch(setActiveTab('slots'));
            navigate('/');
          }}
          item
          xs={12 / 5}
        >
          <Box sx={{ position: 'relative', display: 'inline-block', width: ICON_SIZE, height: ICON_SIZE }}>
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 10,
                pointerEvents: 'none',
              }}
            >
              <CurvedLabel>{translate('home')}</CurvedLabel>
            </Box>

            <Image
              src={Home}
              sx={{
                width: ICON_SIZE,
                height: ICON_SIZE,
                display: 'block',
                position: 'relative',
                zIndex: 1,
              }}
            />
          </Box>
        </MenuGrid>

        <MenuGrid
          onClick={() => {
            setMenuIndex(2);
            dispatch(setActiveTab('slots'));
            navigate('/history/tab');
          }}
          item
          xs={12 / 5}
        >
          <Box sx={{ position: 'relative', display: 'inline-block', width: ICON_SIZE, height: ICON_SIZE }}>
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 10,
                pointerEvents: 'none',
              }}
            >
              <CurvedLabel>{translate('history')}</CurvedLabel>
            </Box>

            <Image
              src={History}
              sx={{
                width: ICON_SIZE,
                height: ICON_SIZE,
                display: 'block',
                position: 'relative',
                zIndex: 1,
              }}
            />
          </Box>
        </MenuGrid>

        <MenuGrid
          item
          xs={12 / 5}
          onClick={() => {
            setMenuIndex(3);
            navigate('/promotion');
          }}
        >
          <Box sx={{ position: 'relative', display: 'inline-block', width: ICON_SIZE, height: ICON_SIZE }}>
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 10,
                pointerEvents: 'none',
              }}
            >
              <CurvedLabel>{translate('promotions')}</CurvedLabel>
            </Box>

            <Image
              src={Promo}
              sx={{
                width: ICON_SIZE,
                height: ICON_SIZE,
                display: 'block',
                position: 'relative',
                zIndex: 1,
              }}
            />
          </Box>
        </MenuGrid>

        <MenuGrid
          item
          xs={12 / 5}
          onClick={() => {
            setMenuIndex(4);
            if (!isAuthenticated) {
              navigate('/auth/login');
            } else {
              navigate('/user/wallet');
            }
          }}
        >
          <Box sx={{ position: 'relative', display: 'inline-block', width: ICON_SIZE, height: ICON_SIZE }}>
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 10,
                pointerEvents: 'none',
              }}
            >
              <CurvedLabel>{translate('deposit')}</CurvedLabel>
            </Box>

            <Image
              src={LiveChat}
              sx={{
                width: ICON_SIZE,
                height: ICON_SIZE,
                display: 'block',
                position: 'relative',
                zIndex: 1,
              }}
            />
          </Box>
        </MenuGrid>

        <MenuGrid
          item
          xs={12 / 5}
          onClick={() => {
            if (!isAuthenticated) {
              navigate('/auth/login');
            } else {
              setMenuIndex(5);
              handleOpen();
            }
          }}
        >
          <Box sx={{ position: 'relative', display: 'inline-block', width: ICON_SIZE, height: ICON_SIZE }}>
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 10,
                pointerEvents: 'none',
              }}
            >
              <CurvedLabel>{translate('settings')}</CurvedLabel>
            </Box>

            <Image
              src={Settings}
              sx={{
                width: ICON_SIZE,
                height: ICON_SIZE,
                display: 'block',
                position: 'relative',
                zIndex: 1,
              }}
            />
          </Box>
        </MenuGrid>
      </Grid>
    </BottomMenuBox>
  );
};

export default BottomMenu;
